import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import classNames from "classnames";
import { Form, ModalBuilder, Modal, useAuthClaims } from "@redriver/cinnamon";
import { useTranslation } from "react-i18next";

const UserImage = ({ loadedAvatar, onChangeAvatar, ...props }) => {
  const { t } = useTranslation("system");
  const { userAvatar } = useAuthClaims();
  const currentAvatar =
    loadedAvatar || process.env.STORAGE_CONTAINER_URL + userAvatar;
  const [uploadedAvatar, setUploadedAvatar] = useState(null);

  return (
    <ModalBuilder
      withForm
      onSubmitted={() => onChangeAvatar(uploadedAvatar)}
      renderTrigger={(showModal) => {
        return !userAvatar ? (
          <Button
            primary
            icon="upload"
            onClick={showModal}
            content={t("Upload_Avatar")}
          />
        ) : (
          <img
            src={currentAvatar}
            alt={t("Avatar_Preview")}
            onClick={showModal}
            style={{
              width: "120px",
              height: "120px",
              objectFit: "cover",
              borderRadius: "50%",
              cursor: "pointer",
            }}
          />
        );
      }}
      renderModal={(modalProps, formProps) => {
        return (
          <Modal.Upload {...modalProps} header={t("Upload_Avatar")}>
            <Form {...formProps}>
              <Form.FileUpload
                field="avatar"
                label={t("Profile_Image")}
                fluid
                className={classNames(
                  "file-upload",
                  props?.value?.avatar && "file-selected",
                )}
                replaceText={t("Upload_Replace_Text")}
                uploadText={t("Upload_Text")}
                fileExtensionTypes={["png", "jpg", "jpeg", "webp"]}
                customValidator={(_, __, ___, { value }) => {
                  if (value?.avatar) {
                    setUploadedAvatar(value.avatar);
                  }
                }}
                fileTypesError={`${t("Profile_Image")} ${t("Upload_Error")}`}
                required
              />
            </Form>
          </Modal.Upload>
        );
      }}
    />
  );
};

export default UserImage;
